import { OccupancyLevelColor, UserSettings } from '@silbo/core';
import { colors } from '@silbo/ui';

export type OccupancyColorSet = { main: string; background: string };

export const OCCUPANCY_LEVEL_COLOR_MAP: Record<OccupancyLevelColor, OccupancyColorSet> = {
  green: {
    main: colors.green[60],
    background: colors.green[5],
  },
  orange: {
    main: colors.orange[50],
    background: colors.orange[5],
  },
  red: {
    main: colors.red[60],
    background: colors.red[5],
  },
  grey: {
    main: colors.grey[60],
    background: colors.grey[5],
  },
};

export const getOccupancyLevelColor = (
  occupancyRate: number | undefined,
  config: UserSettings,
  defaultColor?: OccupancyLevelColor
) => {
  if (occupancyRate == null) {
    return defaultColor ? OCCUPANCY_LEVEL_COLOR_MAP[defaultColor] : OCCUPANCY_LEVEL_COLOR_MAP.green;
  }

  const levels = [...config.occupancyLevels].sort(
    (a, b) => (a.maxOccupancyRate || Infinity) - (b.maxOccupancyRate || Infinity)
  );

  for (const level of levels) {
    if ((level.maxOccupancyRate || Infinity) >= occupancyRate) {
      return OCCUPANCY_LEVEL_COLOR_MAP[level.color];
    }
  }

  return OCCUPANCY_LEVEL_COLOR_MAP[levels[levels.length - 1].color];
};
